import { render, staticRenderFns } from "./LicensePlanAlphaConfiguration.vue?vue&type=template&id=0027b2e4&"
import script from "./LicensePlanAlphaConfiguration.vue?vue&type=script&lang=js&"
export * from "./LicensePlanAlphaConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports